export * from '@primeuix/themes/aura/textarea';
export { default } from '@primeuix/themes/aura/textarea';
